import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';

import { SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MultipleFacilityPublish } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { CommonUtil } from '../../../core/Utils/common-util';
import { HaloLoaderService } from '../../../core/halo-loader/halo-loader.service';
import { HaloToastService } from '../../../core/halo-toast/halo-toast.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { OnDemandClassesService } from '../../services/on-demand-classes.service';
import {
  IBandwidth,
  IconfiramtionCountData,
  IOnDemandClassesAsset,
  IOnDemandClassesEquipment,
  IOnDemandClassesSuperWrapper,
  IOnDemandClassesWrapper,
  IstatusCountData,
} from '../../services/on-demand-classes.service.model';

import { Subscription } from 'rxjs';
import { HaloTipsService } from 'src/app/core/halo-tips/halo-tips';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { environment } from 'src/environments/environment';
import { PreviewModalData } from '../../preview-modal/preview-modal.model';
import { SelectionInfo } from '../../selectors/multi-selection/multi-selection.model';
import { MultiFacilityService } from '../../services/multi-facility.service';

@Component({
  selector: 'app-lf-on-demand-classes',
  templateUrl: './lf-on-demand-classes.component.html',
  styleUrls: ['./lf-on-demand-classes.component.css'],
})
export class LfOnDemandClassesComponent implements OnInit, OnDestroy {
  private isPremium = false;
  private selectionInfo: SelectionInfo;
  private rootscopeSubs: Subscription;

  rootScopeData: RootScopeDeclare;

  productInfoGridData: IOnDemandClassesEquipment[];
  statusCountData: IstatusCountData;
  confirmationCountList: IconfiramtionCountData;
  isEquipmentListFetched = false;
  showDisableModal = false;
  showOutdatedSoftwareModal = false;
  isEnabled = 'true';
  assetList: IOnDemandClassesAsset[] = [];
  showToast = false;
  toastMessage: string;
  consolePermision = 'hasLfodEnabledEquipment';
  LFOnDemandConsoles = ['superman', 'hal'];
  productInfoHeaderColumn: object;
  userPermission = false;
  warningMessage: string | SafeHtml;
  showBandwidthModal = false;
  recommendedBandwidth: IBandwidth[] = [];
  bandwidthList: {
    name: string | undefined;
    unit: number | undefined;
    value: string | undefined;
  }[] = [];
  lfOnDemandHeaderMsg = '';

  disabledPopupProperties = {
    title: 'DISABLE.LF.ON.DEMAND.CLASSES',
    message: 'DISABLE.LF.ON.DEMAND.CLASSES.MSG',
    isWarningPopup: false,
    ctaButtonLabel: 'YES.CONTINUE',
    negativeButtonLabel: 'CANCEL',
    isSecondaryTextButton: true,
  };

  outdatedSoftwarePopupProperties = {};

  productInfoHeaderData = [
    { columnName: 'PRODUCT.INFORMATION' },
    { columnName: 'STATUS' },
    { columnName: 'CONFIRMATION' },
    { columnName: 'SELECT.ALL.EQUIPMENT' },
  ];

  productInfoHeaderDataForXs = [{ columnName: 'STATUS' }, { columnName: 'SELECT.ALL.EQUIPMENT' }];

  displayPreviewModal = false;
  status: string;
  enableBtnLabel: string;

  constructor(
    private rootScopeService: RootScopeService,
    private onDemandClassesService: OnDemandClassesService,
    public commonUtil: CommonUtil,
    private router: Router,
    private amplitudeAnalytics: AmplitudeAnalyticsService,
    private toast: HaloToastService,
    private _facilityService: FacilityService,
    private _multiFacilityService: MultiFacilityService,
    private loader: HaloLoaderService,
    private _tips: HaloTipsService
  ) {}

  showHaloTips() {
    if (this.rootScopeData.showLFODTooltip) {
      this._tips.add([
        {
          flag: 'showLFODTooltip',
          key: 'multi-select-facility',
          message: this.commonUtil.translateText('LF.ON.DEMAND.TOOLTIP.MSG1'),
        },
        {
          flag: 'showLFODTooltip',
          key: 'lfod-enable-disable',
          message: this.commonUtil.translateText('LF.ON.DEMAND.TOOLTIP.MSG2'),
        },
        {
          flag: 'showLFODTooltip',
          key: 'lfod-publish',
          message: this.commonUtil.translateText('LF.ON.DEMAND.TOOLTIP.MSG3'),
          pointerPosition: 'bottom',
        },
      ]);
    }
  }

  getRootScopeData(): void {
    this.rootscopeSubs = this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData;
    });
  }

  setDraftedFlag(): void {
    this.rootScopeData.isPageHasUnsavedChanges = true;
  }

  updateOnDemandData() {
    if (!this.hasPermission()) {
      this.commonUtil.redirectToAvailablePage();
    }
    this.getOnDemandClassesDetails();
  }

  ngOnInit() {
    this.getRootScopeData();
    this.setPageName();
    this.isPremium = !this.router.url.startsWith('/equipmentSettings/lfod');
    if (this.isPremium) {
      this.LFOnDemandConsoles.push('mulder');
      this.consolePermision = 'hasLfodEnabledEquipment';
    }

    this.changeProductInfoHeaderData();
    const moduleTitle =
      this.commonUtil.translateText('HALO.FITNESS.CLOUD') + ' - ' + this.commonUtil.translateText('MENU.EQUIPSETTING');
    this.commonUtil.setTitle(moduleTitle);
    const gettingStartedLink = [
      '<a class="gettingStartedLink"  target="_blank" href="https://halofitness.zendesk.com/hc/en-us/articles/360031436651">' +
        this.commonUtil.translateText('HERE') +
        '</a>',
    ];
    this.warningMessage = this.commonUtil.replaceValueAsHTMLOnTranslatedText(
      'LF.ON.DEMAND.CLASS.WARNING.MSG',
      gettingStartedLink
    );
    this.showHaloTips();

    // static data
    this.recommendedBandwidth = this.onDemandClassesService.recommendedBandwidths();
    this.updateEnableBtnLabel(this.isEnabled === 'true');
  }

  ngOnDestroy() {
    // $('#atlwdg-trigger').css('display', "none");
    // destroy subscriber
    this.rootscopeSubs?.unsubscribe();
    this._tips.onDismissed(true);
  }

  @HostListener('window:resize', ['$event'])
  setScreenSize(): void {
    this.changeProductInfoHeaderData();
  }

  changeProductInfoHeaderData(): void {
    this.productInfoHeaderColumn =
      this.rootScopeData.screenSize == 'xs' || this.rootScopeData.screenSize == 'sm'
        ? this.productInfoHeaderDataForXs
        : this.productInfoHeaderData;
  }

  setPageName(): void {
    this.rootScopeData.pageName = 'onDemandClasses';
  }

  getHeaderMessage() {
    const lfOnDemandTxt = this.getLfOnDemandConsoles();
    this.lfOnDemandHeaderMsg = `${this.commonUtil.replaceValueAsHTMLOnTranslatedText(
      'LF.ON.DEMAND.CLASSES.HEADER.MSG',
      [lfOnDemandTxt]
    )} <a href="https://halofitness.zendesk.com/hc/en-us/articles/360060481692" target="_blank"> ${this.commonUtil.translateText(
      'LEARN.MORE'
    )} </a>`;
  }

  getLfOnDemandConsoles() {
    let supportedConsolesTxt = '';
    const supportedConsoles: string[] = [];
    this.selectionInfo.multiFacilities?.forEach((f) => {
      const fac = this._facilityService.getFacilityById(f);
      fac?.consoleEquipments
        ?.filter((console) => (this.LFOnDemandConsoles.includes(console.consoleType) ? console.consoleType : ''))
        .forEach((console) =>
          supportedConsoles.push(this.rootScopeData.consoleRights.get(console.consoleType).consoleName)
        );
    });
    supportedConsolesTxt = supportedConsoles
      .filter((v, i, a) => a.indexOf(v) === i)
      ?.join(', ')
      .replace(/,(?!.*,)/gim, ' ' + this.commonUtil.translateText('AND'));
    return supportedConsolesTxt;
  }

  getOnDemandClassesDetails() {
    this.userPermission = this.hasEditPermission();
    if (
      this.selectionInfo.consoleType &&
      this.LFOnDemandConsoles.indexOf(this.selectionInfo.consoleType.toString()) > -1
    ) {
      this.loader.startProcess();
      this.onDemandClassesService
        .getOnDemandClasses(
          this._facilityService.selectedMultiFacilities(),
          this.selectionInfo.consoleType,
          this.isPremium ? 'Premium' : 'Basic'
        )
        .subscribe(
          (data: IOnDemandClassesSuperWrapper) => {
            this.loader.endProcess();
            this.isEquipmentListFetched = true;
            data.onDemandClassesWrapper?.forEach((o) =>
              o.equipmentList?.forEach((e) => e.assetList?.forEach((a) => (a.isLfodBasic = true)))
            );
            this.productInfoGridData = this.onDemandClassesService.groupAssetByType(
              data.onDemandClassesWrapper,
              this.selectionInfo.consoleType,
              'lfodEnabledEquipment'
            );
            this.constructDataForStatusLegend();
            this.constructDataForConfirmationLegend();
            this.isEnabled =
              data.onDemandClassesWrapper.filter((c) => c.enabledStatus == 'true')?.length ==
              data.onDemandClassesWrapper.length
                ? 'true'
                : 'false';
            this.updateEnableBtnLabel(this.isEnabled === 'true');
          },
          (error) => {
            console.error('API failed.');
            this.loader.endProcess();
          }
        );
    }
  }

  constructDataForStatusLegend(): void {
    this.statusCountData = {
      connectedCount: this.sumOfArray(this.productInfoGridData.map((p) => p.connectedCount)),
      idleCount: this.sumOfArray(this.productInfoGridData.map((p) => p.idleCount)),
      notConnectedCount: this.sumOfArray(this.productInfoGridData.map((p) => p.notConnectedCount)),
      showIdle: true,
    };
  }

  constructDataForConfirmationLegend(): void {
    this.confirmationCountList = {
      enabledCount: this.sumOfArray(this.productInfoGridData.map((p) => p.enabledCount)).toString(),
      warningCount: this.sumOfArray(this.productInfoGridData.map((p) => p.warningCount)).toString(),
      unknownCount: this.sumOfArray(this.productInfoGridData.map((p) => p.unknownCount)).toString(),
    };
  }

  sumOfArray(array: number[]) {
    return array.reduce((p, c) => p + c);
  }

  assetListDataHandler(assetData: IOnDemandClassesAsset[]): void {
    this.assetList = assetData;
  }

  openBandwidthModal() {
    this.bandwidthList = [];
    const groupedAssets = this.onDemandClassesService.groupBy(this.assetList, (asset) => asset.facilityId);
    groupedAssets?.forEach((v, k) => {
      this.bandwidthList.push({
        name: v[0].facilityName,
        unit: v.length,
        value: this.getbandwith(v.length),
      });
    });
    this.showBandwidthModal = true;
  }

  getbandwith(units: number): string | undefined {
    const banLength = this.recommendedBandwidth.length;
    for (let i = 0; i < banLength; i++) {
      if (this.recommendedBandwidth[i].units > units || i + 1 === banLength) {
        return this.recommendedBandwidth[i].bandwidth;
      } else if (this.recommendedBandwidth[i].units < units && this.recommendedBandwidth[i + 1].units > units) {
        return this.recommendedBandwidth[i + 1].bandwidth;
      }
    }
    return undefined;
  }

  closeBandwidthModal() {
    this.showBandwidthModal = false;
  }

  prepareDataToPublish() {
    if (!this.assetList || this.assetList.length < 1) return undefined;
    const dataToPublish: MultipleFacilityPublish = {
      onDemandClassesUpdateWrapper: [],
    };

    const groupedAssets = this.onDemandClassesService.groupBy(this.assetList, (asset) => asset.facilityId);
    groupedAssets?.forEach((v, k) => {
      dataToPublish.onDemandClassesUpdateWrapper.push({
        facilityId: k,
        consoleType: this.selectionInfo.consoleType,
        assetIds: v.map((a) => a.assetId.toString()),
        lfodEnabledStatus: this.isEnabled === 'true',
        managerId: this.rootScopeData.currentUser.userId,
      });
    });

    return dataToPublish;
  }

  publishOnDemandClasses() {
    const dataToPublish = this.prepareDataToPublish();
    if (!dataToPublish) return;
    this.showBandwidthModal = false;
    this.loader.startProcess();
    this.amplitudeAnalytics.logEvent({
      elementName: this.status,
      action: 'Click',
      additionalProperty: {
        console: this.selectionInfo.consoleType,
        facilityIds: dataToPublish.onDemandClassesUpdateWrapper?.map((o) => o.facilityId),
      },
    });
    this.onDemandClassesService.publishOnDemandClasses(dataToPublish.onDemandClassesUpdateWrapper).subscribe(
      (data: IOnDemandClassesWrapper[]) => {
        this.loader.endProcess();
        this.isEnabled = data[0].lfodEnabledStatus ? 'true' : 'false';
        if (data[0].lfodEnabledStatus) {
          this.setenableToggle();
        }
        this.processPublishResponse(data);
      },
      (error) => {
        this.loader.endProcess();
        if (this.isEnabled === 'true') {
          this.closeBandwidthModal();
        }
        console.error('API failed.');
      }
    );
  }

  stopEventCapturing(e: any) {
    e.stopPropagation();
  }

  checkEnableDisablePublish() {
    if (this.isEnabled === 'true') {
      this.openBandwidthModal();
      this.status = 'Enable';
    } else {
      this.publishOnDemandClasses();
      this.status = 'Disable';
    }
  }

  processPublishResponse(data: IOnDemandClassesWrapper[]) {
    let outdatedAssetCount = 0;
    const additionalMessage: string[] = [];
    data?.forEach((item) => {
      const fac = this._facilityService.getFacilityById(item.facilityId.toString());
      if (item.outdatedAssetCount == 0) {
        if (fac) fac.summary.hasLFODEnabledSetup = 'true';
      } else {
        outdatedAssetCount += Number(item.outdatedAssetCount);
        additionalMessage.push(`${fac?.facilityName} (${item.outdatedAssetCount})`);
      }
    });
    if (outdatedAssetCount > 0) {
      this.showOutdatedSoftwareModal = true;
      this.outdatedSoftwarePopupProperties = {
        title: 'OUTDATED.SOFTWARE.VERSION',
        message: this.commonUtil.replaceValueAsHTMLOnTranslatedText('OUTDATED.SOFTWARE.VERSION.MSG', [
          outdatedAssetCount.toString(),
          '4.10',
        ]),
        needHelp: 'NEED.HELP',
        needHelpLink: 'https://halofitness.zendesk.com/hc/en-us/articles/360031436651',
        isWarningPopup: true,
        ctaButtonLabel: additionalMessage.length > 1 ? 'OK' : 'UPDATE.SOFTWARE',
        negativeButtonLabel: additionalMessage.length > 1 ? '' : 'OK',
        isCloseIconCallsCta: false,
        isSecondaryTextButton: true,
        additionalMessage: additionalMessage,
      };
    } else {
      if (this.isEnabled === 'true') {
        this.toastMessage = this.commonUtil.translateText('LF.ON.DEMAND.CLASSES.ENABLE.PUBSLISH.MSG');
      } else {
        this.toastMessage = this.commonUtil.translateText('LF.ON.DEMAND.CLASSES.DISABLE.PUBSLISH.MSG');
      }
      this.toast.creatToast(this.toastMessage);
    }
    if (this.isEnabled === 'true') {
      this.status = 'Enable';
      this.closeBandwidthModal();
    } else {
      this.status = 'Disable';
    }
    this.rootScopeData.isPageHasUnsavedChanges = false;
    this.updateOnDemandData();
  }

  showDisableConfirmationModal() {
    if (this.isEnabled === 'true') {
      this.showDisableModal = true;
      this.updateEnableBtnLabel(false);
    }
  }
  setenableToggle() {
    if (this.isEnabled === 'false') {
      this.updateEnableBtnLabel(true);
    }
  }
  needHelpLink() {
    //
  }
  onPositiveConfirmation() {
    this.showDisableModal = false;
    this.setDraftedFlag();
  }

  closeDisabledModal() {
    this.isEnabled = 'true';
    this.updateEnableBtnLabel(true);
    this.showDisableModal = false;
  }

  goToSofwarePage() {
    this.router.navigate(['/software']);
  }

  closeOutdatedSoftwareModal() {
    this.showOutdatedSoftwareModal = false;
  }

  closeToast(): void {
    this.showToast = false;
  }

  showPreviewPopup() {
    this.displayPreviewModal = true;
  }

  onPressofCancel() {
    this.displayPreviewModal = false;
  }

  hasEditPermission() {
    if (this.selectionInfo.multiFacilities) {
      return this.selectionInfo.multiFacilities.some((s) => {
        const fac = this._facilityService.getFacilityById(s);
        if (fac?.summary?.userRights?.lfodEnabledEquipment === 'F' || fac?.summary?.isLoggedInManagerAdmin === 'true')
          return true;
        else return false;
      });
    } else {
      return false;
    }
  }

  hasPermission() {
    if (this.selectionInfo.multiFacilities) {
      return this.selectionInfo.multiFacilities.some((s) => {
        const fac = this._facilityService.getFacilityById(s);
        if (
          (fac?.summary?.userRights?.lfodEnabledEquipment !== 'H' || fac?.summary?.isLoggedInManagerAdmin === 'true') &&
          fac?.summary.facilityRights.lfodEnabledEquipment === 'true'
        ) {
          return this._multiFacilityService.isMultifacilityUrl(this.router.url);
        }
        return false;
      });
    }
    return false;
  }

  pageName() {
    if (this.isPremium) {
      return this.commonUtil.translateText('SUBSCRIPTION.LFODP');
    } else {
      return this.commonUtil.translateText('SUBSCRIPTION.LFODB');
    }
  }

  public onSelectionChange(selectionInfo: SelectionInfo) {
    setTimeout(() => {
      this.selectionInfo = selectionInfo;
      this.updateOnDemandData();
      this.getHeaderMessage();
    });
  }

  private updateEnableBtnLabel(isEnabled: boolean) {
    this.enableBtnLabel = `${
      isEnabled ? this.commonUtil.translateText('ENABLE') : this.commonUtil.translateText('DISABLE')
    } ${this.commonUtil.translateText('EQUIPMENT')}`;
  }

  getPreviewData(): PreviewModalData[] {
    return [
      {
        name: this.commonUtil.replaceValueAsHTMLOnTranslatedText('WITH.ON.DEMAND', [
          this.commonUtil.translateText('LF.ON.DEMAND.CLASSES'),
        ]),
        images: [`${environment.cloudBasePath}/Images/Image_VideoLibrary_ViewConsole_LFOD_SE3HD.png`],
        index: 0,
      },
      {
        name: this.commonUtil.replaceValueAsHTMLOnTranslatedText('WITHOUT.ON.DEMAND', [
          this.commonUtil.translateText('LF.ON.DEMAND.CLASSES'),
        ]),
        images: [`${environment.cloudBasePath}/Images/Image_VideoLibrary_ViewConsole_Lifescape_SE3HD.png`],
        index: 1,
      },
    ];
  }
}
